import React, { FC } from 'react';

import { MenuCarousel, useMenuCarouselHandler } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { RewardsCarouselCardV2 } from 'components/rewards-carousel/rewards-carousel-card-v2';

import { IRewardsSectionViewProps } from './types';

export const RewardsSectionViewV2: FC<IRewardsSectionViewProps> = ({ rewards }) => {
  const { formatMessage } = useIntl();
  const totalCards = rewards.length || 0;
  const { menuCarouselProps, menuItemProps } = useMenuCarouselHandler({ totalCards });

  return (
    <MenuCarousel
      {...menuCarouselProps}
      ctaAs={Link}
      ctaHref={`${formatMessage({ id: 'routes.loyaltyHome' })}/list`}
      ctaText={formatMessage({ id: 'viewAll' })}
      header={formatMessage({ id: 'rewards' })}
      nextButtonTitle={formatMessage({ id: 'next' })}
      pageChangeReader={formatMessage(
        { id: 'pageChangedReaderCarousel' },
        {
          firstItemSlide: menuCarouselProps.itemOffset + 1,
          lastItemSlide: menuCarouselProps.lastItemSlide,
          totalCards,
        }
      )}
      previousButtonTitle={formatMessage({ id: 'previous' })}
    >
      {rewards.map((reward, index) => {
        return (
          <RewardsCarouselCardV2
            {...menuItemProps}
            key={`${reward._id}-${index}`}
            reward={reward}
            index={index}
          />
        );
      })}
    </MenuCarousel>
  );
};
